import type {
	FiberStatus,
	Zone
} from '@/types/components/signup'

export function mapZoneToStatus(zone: Zone): FiberStatus {
	switch (zone) {
		case 'in_service':
			return 'internetAvailable'
		case 'remote':
			return 'internetUnavailable'
		case 'extended':
			return 'underConstruction'
		default:
			return 'internetUnavailable'
	}
}

export function mapStatusToZone(status: FiberStatus): Zone {
	switch (status) {
		case 'internetAvailable':
			return 'in_service'
		case 'internetUnavailable':
			return 'remote'
		case 'underConstruction':
			return 'extended'
		default:
			return 'remote'
	}
}

export function mapLabelToStatus(label: string, hasBillables: boolean): FiberStatus {
	// Handle special cases for billables
	if (label === 'Closed Out' && hasBillables) return 'internetAvailable'
	if (label === 'As-Built-ing' && !hasBillables) return 'underConstruction'

	// Handle default cases
	switch (label) {
		case 'Closed Out':
		case 'As-Built-ing':
			return 'internetAvailable'
		case 'Building':
			return 'underConstruction'
		default:
			return 'internetUnavailable'
	}
}
